<template>
  <div class="custom-control custom-switch">
    <input
      type="checkbox"
      class="custom-control-input"
      :id="id"
      :checked="value"
      @change="$emit('input', $event.target.checked)"
    />
    <label
      class="custom-control-label text-lable"
      :for="id"
      :style="{ fontSize: '14px', fontWeight: '500' }"
    >
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      required: true,
    },
  },
};
</script>
